import React from "react";

const pontos = [
  {
    titulo: "Você não sai da fazenda para comprar.",
    texto:
      "O pedido fecha do celular e a entrega vai para o roteiro que você já cadastrou. Sem viagem até a loja e sem depender de quem está indo à cidade.",
  },
  {
    titulo: "Você não liga para cotar.",
    texto:
      "O preço de cada embalagem já está no catálogo, com o mínimo de compra e o frete. Cotação existe só para o que o seu parceiro ainda não cadastrou.",
  },
  {
    titulo: "Você acha rápido o que procura.",
    texto:
      "Busca por nome, por segmento ou pelo parceiro. O que você repõe sempre fica salvo nos favoritos, pronto para repetir o pedido.",
  },
  {
    titulo: "Os parceiros em quem você já confia, agora no seu tempo.",
    texto:
      "Não é fornecedor novo. São as mesmas empresas com quem você já negocia, agora com o catálogo na sua mão e o pedido saindo na hora que der para você.",
  },
];

const Dores: React.FC = () => (
  <section className="border-b border-bone-300 bg-white">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-24">
      <h2 className="eyebrow">O que a gente resolve</h2>

      <div className="mt-10 divide-y divide-bone-300 border-y border-bone-300">
        {pontos.map((p) => (
          <div
            key={p.titulo}
            className="grid gap-3 py-8 lg:grid-cols-[1.15fr_1fr] lg:gap-14 lg:py-10"
          >
            <h3 className="font-display text-display-sm font-bold leading-[1.1] text-soil">
              {p.titulo}
            </h3>
            <p className="max-w-xl self-center text-base leading-relaxed text-soil/70">
              {p.texto}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Dores;
